import { render, staticRenderFns } from "./RequireNewPassword.vue?vue&type=template&id=45da57a2"
import script from "./RequireNewPassword.vue?vue&type=script&lang=js"
export * from "./RequireNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports